<template>
  <van-tabs class="data-cnt" v-model:active="tabActive" @change="routeTo('/?tab=' + tabActive)" color="#07c160">
    <van-tab v-if="showDataTab" name="data" title="Dacal秒表">
      <div class="download-ctn">
        <p>欢迎下载Dacal秒表APP</p>

        <div>
          <div class="download-wrap">
              <a v-if="isIOS" target="_blank" href="itms-services://?action=download-manifest&url=https://www.haoping.fun/download/ios/manifest.plist"><Button type="primary">IOS下载</Button></a>
<!--              <p v-if="isIOS">应用未签名, 请加入QQ群: 1031191163 找群主处理。</p>-->
              <a v-else download="dacal.apk" target="_blank" href="https://www.haoping.fun/download/dacal-v1.0.1.apk"><Button type="primary">安卓下载</Button></a>
            &nbsp; <Button type="default" @click="showDownloadQRC=!showDownloadQRC">{{showDownloadQRC ? "收起二维码":"扫码下载"}}</Button>
          </div>
          <p v-if="showDownloadQRC">
            <van-image :src="downloadQr">
              <template v-slot:error>
                下载失败，
                <ClipbordComponent v-if="isIOS"  :show-content="true" btn-text="复制链接" text="itms-services://?action=download-manifest&url=https://www.haoping.fun/download/ios/manifest.plist" show-copy-button="true"/>
                <ClipbordComponent v-else  :show-content="true" btn-text="复制链接" text="https://www.haoping.fun/download/dacal-v1.0.1.apk" show-copy-button="true"/>
              </template>
            </van-image>
          </p>
        </div>
        <div class="ctn-desc">
          <h1>【核心特色】</h1>
          <h4>飘屏数据汇总、分析、预测工具</h4>
          <p id="u62d50615" data-lake-id="u62d50615">
            <ne-text id="ub5cee886" ne-bold="true">悬浮秒表:&nbsp;</ne-text>
            <ne-text id="uda533f0f">可以在任意app上悬浮！ 可在手机界面上悬浮！帮你卡点计时！</ne-text><span class="ne-viewer-b-filler" ne-filler="block"><br></span>
          </p>
          <p id="u62d50615" data-lake-id="u62d50615">
            <ne-text id="ub5cee886" ne-bold="true">飘屏数据播报:&nbsp;</ne-text>
            <ne-text id="uda533f0f">还在为聊天室不知道5.0是否出了烦恼吗? 还在为蹲48.0在直播间蹲守一晚上吗?</ne-text><span class="ne-viewer-b-filler" ne-filler="block"><br></span>
          </p>
          <p id="u62d50615" data-lake-id="u62d50615">
            <ne-text id="ub5cee886" ne-bold="true">红包助手:&nbsp;</ne-text>
            <ne-text id="uda533f0f">太烦了！家族红包永远看不到？大家都坐在路由器上的是吧? 快安装我，带你住在他趣服务器上, 再也不会错过红包了!</ne-text><span class="ne-viewer-b-filler" ne-filler="block"><br></span>
          </p>
          <p id="u62d50615" data-lake-id="u62d50615">
            <ne-text id="ub5cee886" ne-bold="true">玩乐教程:&nbsp;</ne-text>
            <ne-text id="uda533f0f">看看大佬们好厉害，摩天轮、魔法气球、抓娃娃都会卡点！我也想学！快下载我, 带你也变成大佬!</ne-text><span class="ne-viewer-b-filler" ne-filler="block"><br></span>
          </p>
        </div>
        <div>
          <h1 id="zmM69" data-lake-id="zmM69" style="text-align: left;">
            <span id="u07c97197">【功能预览】</span><span class="ne-viewer-b-filler" ne-filler="block"><br></span>
          </h1>
          <div class="ne-card-container">
            <div class="ne-image-wrap ne-image-loaded ne-image-style-none">
              <div class="ne-image-box" style="">
                <p style="text-align: left;"><ne-text id="ub5cee886" ne-bold="true">实时飘屏悬浮窗</ne-text></p>
                <img style="width: 100%;" class="ne-image ne-image-preview" alt="实时飘屏悬浮窗" draggable="true" :src="dacalPreview2">
              </div>
              <br/><br/>
              <div class="ne-image-box" style="">
                <p style="text-align: left;"><ne-text id="ub5cee886" ne-bold="true">历史记录查询</ne-text></p>
                <img style="width: 100%;" class="ne-image ne-image-preview" alt="历史记录查询" draggable="true" :src="dacalPreview">
              </div>
              <br/><br/>
              <div class="ne-image-box" style="">
                <p style="text-align: left;"><ne-text id="ub5cee886" ne-bold="true">统计数据查询</ne-text></p>
                <img style="width: 100%;" class="ne-image ne-image-preview" alt="统计数据查询" draggable="true" :src="dacalPreview3">
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-tab>
    <van-tab v-if="showFamilyTab" name="family" title="他趣家族助手" badge="新">
      <div class="download-ctn">
        <p>欢迎下载他趣家族助手</p>

        <div>
          <p class="download-wrap">
            <a href="https://www.haoping.fun/download/family-v1.0.12.apk" target="_blank"><Button type="primary">安卓下载</Button></a>
          </p>
        </div>
        <div class="ctn-desc">

          <div class="ne-viewer lakex-yuque-theme-light ne-typography-classic ne-paragraph-spacing-relax ne-viewer-layout-mode-fixed">
            <div class="ne-viewer-body">
              <div>
                <h1 id="yHBcD" data-lake-id="yHBcD">
                  <ne-heading-content>
                    <ne-text id="u21550f08">【核心特色】</ne-text><span class="ne-viewer-b-filler" ne-filler="block"><br></span>
                  </ne-heading-content>
                </h1>
                <h4>他趣家族新人招募、家族成员留存、僵尸清退助手, 族长日常管理好最好的帮手！</h4>
                <p id="u62d50615" data-lake-id="u62d50615">
                  <ne-text id="ub5cee886" ne-bold="true">文字招募:&nbsp;</ne-text>
                  <ne-text id="uda533f0f">定时在广场各频道自动发送招募广告.24小时不停歇, 提高家族曝光率，刷新大家对家族认知度。</ne-text><span class="ne-viewer-b-filler" ne-filler="block"><br></span>
                </p>
                <p id="uce2a6f8a" data-lake-id="uce2a6f8a">
                  <ne-text id="u11d3e1fa" ne-bold="true">红包招募:&nbsp;</ne-text>
                  <ne-text id="u20ee9003">自动发送家族招募红包, 以红包吸引用户加入家族。</ne-text><span class="ne-viewer-b-filler" ne-filler="block"><br></span>
                </p>
                <p id="u5c66f137" data-lake-id="u5c66f137">
                  <ne-text id="uef50e27a" ne-bold="true">私信招募:&nbsp;</ne-text>
                  <ne-text id="ue6edafc1">发现广场无家族用户自动发送家族邀请链路, 邀请用户加入, 官方不推流，我们自己推流。</ne-text><span class="ne-viewer-b-filler" ne-filler="block"><br></span>
                </p>
                <p id="ufc080c88" data-lake-id="ufc080c88">
                  <ne-text id="u03192931" ne-bold="true">远程操作:</ne-text>
                  <ne-text id="u201642d7">可远程随时调整招募文案, 招募策略,停止招募或启动招募, 监控执行情况。</ne-text><span class="ne-viewer-b-filler" ne-filler="block"><br></span>
                </p>
                <p id="u5ed62b33" data-lake-id="u5ed62b33">
                  <ne-text id="u7df298b2" ne-bold="true" style="color: rgb(223, 42, 63);">家族管家:&nbsp;</ne-text>
                  <ne-text id="ub16b1cee">家族自动欢迎新人, 发送族规, 定时提醒成员完成家族任务。</ne-text><span class="ne-viewer-b-filler" ne-filler="block"><br></span>
                </p>
              </div>
              <div>
                <h1 id="zmM69" data-lake-id="zmM69">
                  <span id="u07c97197">【招募效果】</span><span class="ne-viewer-b-filler" ne-filler="block"><br></span>
                </h1>
                <div class="ne-card-container">
                  <div class="ne-image-wrap ne-image-loaded ne-image-style-none">
                    <div class="ne-image-box" style="">
                      <img style="width: 100%;" class="ne-image ne-image-preview" alt="招募效果" draggable="true" :src="crewEffects">
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <h1 id="GXQWH" data-lake-id="GXQWH">
                  <span id="ufb0c6099">【功能预览】</span><span class="ne-viewer-b-filler" ne-filler="block"><br></span>
                </h1>
                <div class="ne-card-container">
                  <div class="ne-image-wrap ne-image-loaded ne-image-style-none" data-testid="ne-card-image">
                    <div class="ne-image-box" style="">
                      <img style="width: 100%;" class="ne-image ne-image-preview" alt="image.png" draggable="true" :src="fuctionPreview">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-tab>
    <van-tab v-if="showDoumiTab" name="ailiao" title="爱聊家族助手" badge="新">
      <div class="download-ctn">
        <p>欢迎下载爱聊家族助手</p>

        <div>
          <p class="download-wrap">
            <a href="https://www.haoping.fun/download/ailiao-v1.0.12.apk" target="_blank"><Button type="primary">安卓下载</Button></a>
          </p>
        </div>
      </div>
    </van-tab>
  </van-tabs>
  <p style="color: #cccccc; bottom:0; width: 100%;">
      <a  style="color: #cccccc;" href="https://beian.miit.gov.cn/" target="_blank">浙ICP备2023043242号-1</a>
  </p>
</template>
<style lang="less">
.download-ctn {
    font-family: Arial, sans-serif;
    text-align: center;
    padding: 20px;
    h1 {
        color: #333;
    }
    p {
        color: #333;
        margin-bottom: 20px;
    }
    .download-button {
        display: inline-block;
        padding: 10px 20px;
        text-decoration: none;
        border-radius: 5px;
        font-weight: bold;
    }
    a {
        color: inherit;
    }

    .ctn-desc{
        text-align: left;
    }
}

</style>
<script>
import {Button} from "vant";
import {ref, onMounted} from "vue";
import downloadQr from "@/assets/download_qr.png"
import crewEffects from "@/assets/family-data.png"
import fuctionPreview from "@/assets/family-config.png"
import dacalPreview from "@/assets/dacal-preview1.jpg"
import dacalPreview2 from "@/assets/dacal-preview2.jpg"
import dacalPreview3 from "@/assets/dacal-preview3.jpg"
import API from "@/api";
import {getUrlParam} from "@/utils/util";
import {useRouter} from "vue-router";
import store from "@/store";
import ClipbordComponent from "@/components/Clipbord.vue";

const tabMap = {
  "FamilyMember": "family",
  "DataMember": "data",
  "DoumiMember": "doumi",
};

export default{
    name: "StartDownload",
    components: {ClipbordComponent, Button},
    setup(){

      const showDownloadQRC = ref(false);
      let tab = getUrlParam("tab");
      const tabActive = ref(tab || "data");
      const router = useRouter();
      let shareToken = getUrlParam("share_token");
      const bizType = store.userStore().getBizType();


      if(shareToken){
        localStorage.setItem("shareToken", shareToken);
      }else{
        shareToken = localStorage.getItem("shareToken");
      }

      onMounted(() => {

        if(!shareToken){
          return;
        }

        const key = "download_send_flag";
        const downloadSendFlag = localStorage.getItem(key);
        if(!downloadSendFlag){
          API.share.downloadRecord(shareToken).then((res) => {
            if(res.success){
              localStorage.setItem(downloadSendFlag, shareToken);
            }
          });
        }

      });

      if(tab === null){
        tab = tabMap[bizType];
      }

      const showFamilyTab = true;
      const showDataTab = true;
      const showDoumiTab = true;

      const goToUrl = (url) => location.href = url;
      const routeTo = (path) => router.push(path);
      const isIOS  = /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent);

      return {
        showDownloadQRC,
        tabActive,
        downloadQr,
        crewEffects,
        fuctionPreview,
        dacalPreview,
        dacalPreview2,
        dacalPreview3,
        goToUrl,
        showFamilyTab,
        showDataTab,
        showDoumiTab,
        isIOS,
        routeTo
      };
    }
}
</script>
